import { createFileRoute } from "@tanstack/react-router";

function ActionsIndex() {
  return null;
}

export const Route = createFileRoute("/$workspaceSlug/admin/actions/")({
  component: ActionsIndex,
});
